import {createElevation} from "../../helpers";
export default createElevation;